import TextFieldMaterial from '@mui/material/TextField';
import PropTypes from 'prop-types';

const TextField = ({ error, helperText, inputProps, label, ...other }) => {
  return (
    <TextFieldMaterial
      error={error}
      helperText={helperText}
      inputProps={inputProps}
      label={label}
      variant="outlined"
      {...other}
    />
  );
};

TextField.propTypes = {
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  inputProps: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
};

TextField.defaultProps = {
  error: false,
  fullWidth: true,
  helperText: ' ',
  inputProps: {},
  label: undefined,
  margin: 'normal',
};

export default TextField;
